<template>
    <div class="number-select">
        <div class="button minus"
            :class="{disabled: !minus}"
            @click="decrease"
            ></div>
        <div class="button plus"
            :class="{disabled: !plus}"
            @click="increase"
            ></div>
        <div :class="{input: true, invalid: !isValid}">
            <input type="text" readonly :value="value">
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            required: true,
            default: 0
        },
        min: {
            default: 0
        },
        max: {},
        step: {
            default: 1
        }
    },

    computed: {
        minus: function() {
            return this.value > (this.min % this.step ? (this.min + this.step - this.min % this.step) : this.min);
        },
        plus: function() {
            return this.value < (this.step <= 1 ? this.max : (this.max - this.max % this.step));
        },
        isValid () {
            return !(this.value % this.step) && this.value >= this.min && this.value <= this.max;
        }
    },

    watch: {
        // max (val) {
        //     if (this.value > val) {
        //         this.$emit('change', val);
        //     }
        // }
    },

    methods: {
        decrease: function() {
            if (this.minus) {
                let newValue = this.value - (this.isValid ? this.step : 1) ;
                if (newValue >= this.min) {
                    this.$emit('manuChangeRoom');
                    this.$emit('change', newValue);
                }
            }
        },

        increase: function() {
            if (this.plus) {
                let newValue = this.value + (this.isValid ? this.step : 1);
                if (newValue <= this.max) {
                    this.$emit('manuChangeRoom');
                    this.$emit('change', newValue);
                }
            }
        }
    }
}
</script>

<style lang="scss">
.number-select {
    .button {
        float: left;
        position: relative;
        box-sizing: border-box;
        width: 26px;
        height: 26px;
        border-radius: 100px;
        border: 1px solid #32c45d;
        @supports (border-width: 0.5px) {
            border-width: 0.5px;
        }
        touch-action: manipulation;
        &:before {
            content: "";
            position: absolute;
            left: 50%;
            top: 50%;
            width: 10px;
            height: 2px;
            margin: -1px 0 0 -5px;
            background: #32c45d;
        }

        &.disabled {
            border: 1px solid #b7c3ca;
            @supports (border-width: 0.5px) {
                border-width: 0.5px;
            }
            &:before,
            &:after {
                background: #b7c3ca;
            }
        }
    }

    .minus {
        float: left;
    }

    .plus {
        float: right;

        &:after {
            content: "";
            position: absolute;
            left: 50%;
            top: 50%;
            width: 10px;
            height: 2px;
            margin: -1px 0 0 -5px;
            background: #32c45d;
            transform: rotate(90deg);
        }
    }

    .input {
        margin: 0 26px;
        position: relative;
        &:after {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            z-index: 1;
        }

        input {
            display: block;
            width: 100%;
            height: 26px;
            margin: 0;
            padding: 0;
            border: 0;
            background: none;
            color: #383838;;
            line-height: 26px;
            text-align: center;
            font-size: 15px;
        }

        &.invalid {
            input {
                color: #f00;
            }
        }
    }

}
</style>



// WEBPACK FOOTER //
// NumberSelect.vue